import React from 'react';
import Moment from 'react-moment';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

const formatDuration = (requestedOn, receivedOn) => {
  if (!requestedOn || !receivedOn) {
    return '';
  }

  try {
    const requestTime = new Date(requestedOn);
    const receivedTime = new Date(receivedOn);

    if (isNaN(requestTime.getTime()) || isNaN(receivedTime.getTime())) {
      return '';
    }

    const durationMs = receivedTime.getTime() - requestTime.getTime();

    if (durationMs < 0) {
      return '';
    }

    if (durationMs < 1000) {
      return `${durationMs}ms`;
    }

    const seconds = (durationMs / 1000).toFixed(2);
    return `${seconds}s`;
  } catch (error) {
    // Silently handle error and return empty string
    return '';
  }
};

const ListRow = ({ log, expand, onRowClick }) => {
  const getWrapperClassColor = () => {
    const responseStatusCode = log.responseStatusCode || null;

    if (responseStatusCode >= 200 && responseStatusCode < 300) {
      return 'text-success';
    }

    if (responseStatusCode >= 400) {
      return 'text-danger';
    }

    return 'text-info';
  };

  return (
    <tr className={`${getWrapperClassColor()}`}>
      <td>
        <Button color="link" onClick={onRowClick}>
          <i className={expand ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'} />
        </Button>
      </td>
      <td>
        <Moment format="Do MMM YYYY, HH:mm" withTitle>
          {log.createdOn}
        </Moment>
      </td>
      <td>
        <Moment format="Do MMM YYYY, HH:mm" withTitle>
          {log.requestedOn}
        </Moment>
      </td>
      <td>{formatDuration(log.requestedOn, log.receivedOn)}</td>
      <td>{log.correlationId}</td>
      <td>{log.integrationShortName}</td>
      <td>{log.operationShortName}</td>
      <td>{log.responseStatusCode ?? 'N/A'}</td>
    </tr>
  );
};

ListRow.propTypes = {
  log: PropTypes.shape({
    createdOn: PropTypes.string,
    requestedOn: PropTypes.string,
    receivedOn: PropTypes.string,
    correlationId: PropTypes.string,
    integrationShortName: PropTypes.string,
    operationShortName: PropTypes.string,
    responseStatusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  expand: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default ListRow;
